<template>
  <div v-if="loading">
    Loading project invoices
  </div>
  <div v-else class="container" id="invoices-accordion">
    <!--<h4>Invoices:</h4>-->
    <div class="debug">
      <p><b>debugging Project-invoices.vue:</b></p>
      <p>route.params = {{ $route.params }}</p>
      <p>currentProject = {{ currentProject }}</p>
      <p>invArr.length = {{ currentProject.invoices.length }}</p>
      <p>invoice array model = {{ currentProject.invoices }}</p>
      <p>reactive nav items = {{ invNavItems }} </p>
    </div>

    <div>
      <NavBar v-model:navItems="invNavItems" :level=4></NavBar>
    </div>

    <Suspense>
      <template #default>
        <RouterView></RouterView>
      </template>
      <template #fallback> loading project invoices... </template>
    </Suspense>
  </div>

  <!--div class="debug">
        
        <p>current project = {{ currentProject }}</p>
    
    </div>-->
</template>

<script setup lang="ts">
import { computed } from 'vue'
import NavBar from '@/components/Nav-bar.vue'
import { RouterView } from 'vue-router'
import { useCurrentProject } from '@/composables/Current-project'

const { currentProject, loading } = useCurrentProject();

function compareFn(one, two){
  const a = one.text;
  const b = two.text;
  if(a < b){
      return -1;
  }else if (a > b){
      return 1;
  }
  //they must be equal
  return 0;
}

const invNavItems = computed(() => {
  console.log("=== invNavItems computed ===");
  const navItems = currentProject.value.invoices.map((inv) => {
    //return { to: `/projects/${props.projectId}/invoices/${inv.id}`, name: `Invoice-${inv.id}` };
    return {
      to: { name: 'project_invoice', params: { invoiceId: inv.id } },
      text: `Invoice-${inv.id}`
    }
  })
  navItems.sort(compareFn);

  navItems.push({ to: { name: 'create_invoice' }, text: 'New Invoice' }) //, params: { 'customer' : currentCustomer}});
  return navItems
})
</script>
